import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=46bacd6c&"
import script from "./Outro.vue?vue&type=script&lang=ts&"
export * from "./Outro.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./Outro.vue?vue&type=style&index=0&lang=stylus&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports